import styled from "@emotion/styled"
import { wv_willfade } from "./../styles"
import { bold, light, body50, headline30, headline50 } from "css/text"
import getMediaQuery, { media } from "css/breakpoints"

export const Main = styled.section`
  position: absolute;
  top: 0;
  z-index: 1;
  padding-block: calc(var(--spacing) + 1ex);
  padding-inline: var(--outer-margin);
  pointer-events: none;

  & > h2 {
    display: none;
    ${headline30}
    & > span {
      font-size: 1.2em;
    }
  }

  ${getMediaQuery("xl")} {
    & > h2 {
      display: block;
    }
  }

  & > section {
    position: relative;
    padding: 0;
  }
`
